import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify';
import _ from 'lodash';

export function ClassificationManagerRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.ClassificationManager', {
		url: '/admin/classifications',
		controllerAs: 'vm',
		controller: ClassificationManagerCtrl,
		templateUrl: '/ng/hub/Classification/Manager/ClassificationManagerCtrl.html?' + window.BUILD,
		permission: ['manage_classifications'],
		resolve: {
			$style: () => AssetManager.css('/ng/hub/Classification/Manager/ClassificationManagerCtrl.css'),
			$title: () => 'Manage Classifications',
			classifications: ApiResourcify.endpoint('/classifications'),
			icons: ApiResourcify.endpoint('/classifications/icons'),
		},
		onExit: Taxonomy => {
			'ngInject';
			Taxonomy.clearClassifications();
		},
	});
}

export class ClassificationManagerCtrl {
	constructor(Api, modal, classifications, icons) {
		'ngInject';
		this.Api = Api;
		this.modal = modal;
		AssetManager.css('/assets/fonts/Linearicons/style.css').then(() => {
			this.icons = icons;
			this.classifications = classifications;
			this.currCls = {};
			this.suggestedColors = [
				'#E91E63',
				'#87009F',
				'#5d1ec7',
				'#0d1994',
				'#1D7FEF',
				'#08bfc3',
				'#0aa790',
				'#209215',
				'#79B939',
				'#e0d50e',
				'#FDB40C',
				'#FC8408',
				'#c7460e',
				'#f90303',
				'#644237',
				'#8B8B8B',
				'#774d5f',
				'#535761',
				'#000000' /*custom*/,
			];
		});
	}

	save() {
		if (!this.currCls.name || !this.currCls.color || !this.currCls.icon) {
			this.modal.alert({ text: 'Name, color and icon fields are required.' });
			return;
		}
		if (this.isAdding) {
			this.classifications.push(this.currCls);
			this.Api.request('POST', '/classifications', this.currCls).then(resp => {
				this.currCls.id = resp.headers('API-New-Record-Id');
				this.reset();
			});
		} else {
			// editing
			const cls = _.find(this.classifications, { id: this.currCls.id });
			_.extend(cls, this.currCls);
			this.Api.patch('/classifications/' + this.currCls.id, this.currCls);
			this.reset();
		}
	}

	reset() {
		this.currCls = {};
		this.isAdding = false;
		this.isEditing = false;
		this.isAddingOrEditing = false;
	}

	addNew() {
		this.isAdding = true;
		this.isAddingOrEditing = true;
	}

	edit(cls) {
		this.currCls = _.clone(cls);
		this.isEditing = true;
		this.isAddingOrEditing = true;
	}

	delete(cls) {
		const areYouSurePrompt = `
		Are you sure you want to delete <b>${_.escape(cls.name)}</b>?
		<br><br>This cannot be undone.`;
		this.modal.confirm({ escapedHtml: areYouSurePrompt }).then(() => {
			this.classifications.splice(this.classifications.indexOf(cls), 1);
			this.Api.delete('/classifications/' + cls.id);
		});
	}

	updateOrder() {
		this.classifications.forEach((cls, i) => {
			if (cls.sort === i + 1) {
				return;
			}
			cls.sort = i + 1;
			this.Api.patch(`/classifications/${cls.id}`, {
				sort: i + 1,
			});
		});
	}
}
